import { sortBy } from 'lodash';
import { EventMarketItemType } from 'src_common/common/websocket2/modelsApi/EventMarkets';
import { GroupedEventMarkets } from './shared';

export const sortMarketGroups = (markets: GroupedEventMarkets): Array<string> => {
    return sortBy(
        Object.keys(markets),
        (id) => {
            let market = markets[id] ?? [];
            if (id === 'goalscorer') {
                const sortedSubMarkets = markets[id]?.sort((a: EventMarketItemType, b: EventMarketItemType) => {
                    return a.displayOrder - b.displayOrder;
                });
                market = sortedSubMarkets ?? [];
            }

            return market[0]?.displayOrder ?? 0;
        },
        (id) => {
            const market = markets[id] ?? [];
            return market[0]?.name;
        }
    );
};
